<template>
  <base-modal
    ref="modal"
    class="modal-auto-height transfer-modal text-left company-settings-modal"
    :show-close-button="false"
    size="auto"
    style="width:450px"
    title="Company settings"
    @submit="onSubmit"
  >
    <template #content>
      <div class="company-settings-wrapper">
        <advanced-card
          :init-collapsed="false"
          title="Tracking"
        >
          <div class="list-item">
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="settings-native-tracking-enabled"
                  v-model:value="settings.tracking.nativeTracking"
                  label="Use native adtron tracking"
                />
              </div>
            </div>
          </div>
        </advanced-card>

        <advanced-card
          :init-collapsed="false"
          title="Campaign list"
        >
          <div class="list-item">
            <div class="form-group">
              <label class="input-label">
                Sort campaigns by
              </label>
              <input-dropdown
                class="without-highlight"
                :options="campaignOrderByOptions"
                placeholder="Select sort order"
                :allow-empty="false"
                :preselect-first="true"
                :searchable="false"
                :show-labels="false"
                style="height:38px"
                :track-by="null"
                :min-width="222"
                :value="campaignOrderByOptions.find(option => option.value === settings.sortCampaignsBy)"
                :max-width="222"
                @input="updateSortCampaignsBy"
              >
                <template #single-option="{ option }">
                  {{ option.name }}
                </template>
                <template #option-row="{ option }">
                  {{ option.name }}
                </template>
              </input-dropdown>
            </div>
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="show-full-length-campaign-name"
                  v-model:value="settings.showFullLengthCampaignName"
                  label="Show full length campaign name"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="show-full-length-design-name"
                  v-model:value="settings.showFullLengthDesignName"
                  label="Show full length design name"
                />
              </div>
            </div>
          </div>
        </advanced-card>

        <advanced-card
          :init-collapsed="false"
          title="Click Macro"
        >
          <div class="list-item">
            <div class="form-group">
              <input-dropdown
                class="without-highlight"
                :options="availableClickMacros"
                :allow-empty="false"
                placeholder="Select Macro "
                :preselect-first="true"
                :searchable="false"
                :show-labels="false"
                style="height:38px"
                :min-width="222"
                :track-by="null"
                :max-width="222"
                :value="settings.proTab.clickMacro.name"
                @input="updateClickMacro"
              >
                <template #single-option="{ option }">
                  {{ option }}
                </template>
                <template #option-row="{ option }">
                  {{ option }}
                </template>
              </input-dropdown>
            </div>
          </div>
          <div
            v-if="settings.proTab.clickMacro.name==='Custom'"
            class="list-item"
          >
            <div class="form-group">
              <label class="input-label">
                Custom Click Macro
              </label>
              <div class="inline">
                <text-input
                  v-model:value="settings.proTab.clickMacro.customClickMacro"
                  :height="38"
                  :max-width="222"
                  :min-width="222"
                />
              </div>
            </div>
          </div>
        </advanced-card>

        <advanced-card
          :init-collapsed="false"
          title="Ad Dimension"
        >
          <div class="list-item">
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="adtag-custom-adsize-enabled"
                  v-model:value="settings.proTab.adSize.enabled"
                  label="Enable override"
                />
              </div>
            </div>
            <template v-if="settings.proTab.adSize.enabled">
              <div class="form-group adtags-adsize">
                <text-input
                  id="adtag-custom-adsize-dimensionsW"
                  :is-draggable="true"
                  :max-width="105"
                  :min-width="105"
                  name="dimensionsW"
                  suffix="W"
                  type="text"
                  :value="settings.proTab.adSize.width"
                  @change="updateCustomAdWidth"
                />
                <text-input
                  id="adtag-custom-adsize-dimensionsH"
                  :is-draggable="true"
                  :max-width="105"
                  :min-width="105"
                  name="dimensionsH"
                  suffix="H"
                  type="text"
                  :value="settings.proTab.adSize.height"
                  @change="updateCustomAdHeight"
                />
              </div>
            </template>
          </div>
        </advanced-card>

        <advanced-card
          :init-collapsed="false"
          title="Enable special format"
        >
          <div class="list-item">
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="adtag-special-format-enabled"
                  label="Activate special format"
                  :value="settings.proTab.specialFormat.enabled"
                  @input="updateSpecialFormatEnabled"
                />
              </div>
            </div>
          </div>
          <div
            v-if="settings.proTab.specialFormat.enabled"
            class="list-item"
          >
            <div class="form-group">
              <input-dropdown
                class="without-highlight"
                :options="availableSpecialFormats"
                placeholder="Select Format "
                :allow-empty="false"
                :preselect-first="true"
                :searchable="false"
                :show-labels="false"
                style="height:38px"
                :track-by="null"
                :min-width="222"
                :value="settings.proTab.specialFormat.name"
                :max-width="222"
                @input="updateSpecialFormatName"
              >
                <template #single-option="{ option }">
                  {{ option.charAt(0).toUpperCase() + option.slice(1) }}
                </template>
                <template #option-row="{ option }">
                  {{ option.charAt(0).toUpperCase() + option.slice(1) }}
                </template>
              </input-dropdown>
            </div>
          </div>
          <div
            v-if="settings.proTab.specialFormat.enabled && settings.proTab.specialFormat.name==='interstitial'"
            class="list-item"
          >
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="adtag-interstitial-prevent-scroll"
                  v-model:value="settings.proTab.specialFormat.options.preventScroll"
                  label="Prevent scroll"
                />
              </div>
            </div>
          </div>
          <div
            v-if="settings.proTab.specialFormat.enabled && settings.proTab.specialFormat.name==='interscroller'"
            class="list-item"
          >
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="adtag-interscroller-adjust-frame"
                  v-model:value="settings.proTab.specialFormat.options.fullHeightMode"
                  label="Adjust frame"
                />
              </div>
            </div>
          </div>
          <div
            v-if="settings.proTab.specialFormat.options.fullHeightMode"
            class="list-item"
          >
            <label class="input-label">Adjust frame</label>
            <div class="form-group adtags-frame">
              <text-input
                id="adtag-interscroller-frame-dimensionsW"
                :max-width="105"
                :is-draggable="true"
                :min-width="105"
                name="dimensionsW"
                suffix="W"
                type="text"
                :value="settings.proTab.specialFormat.options.width"
                @change="updateInterscrollerFrameWidth"
              />
              <text-input
                id="adtag-interscroller-frame-dimensionsH"
                :max-width="105"
                :is-draggable="true"
                :min-width="105"
                name="dimensionsH"
                suffix="H"
                type="text"
                :value="settings.proTab.specialFormat.options.height"
                @change="updateInterscrollerFrameHeight"
              />
            </div>
          </div>
          <div
            v-if="settings.proTab.specialFormat.name==='interscroller'"
            class="list-item"
          >
            <label class="input-label">Viewability show threshold</label>
            <div class="form-group">
              <text-input
                id="adtag-interscroller-frame-viewability-show-threshold"
                :max-width="100"
                :is-draggable="true"
                :min-width="0"
                name="viewabilityShowThreshold"
                suffix="%"
                type="text"
                :value="viewabilityShowThresholdPercent"
                @change="updateInterscrollerViewabilityShowThreshold"
              />
            </div>
          </div>
          <div
            v-if="settings.proTab.specialFormat.enabled && settings.proTab.specialFormat.name==='interscroller'"
            class="list-item"
          >
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="adtag-interscroller-show-bars"
                  v-model:value="settings.proTab.specialFormat.options.showBars"
                  label="Enable Ad Scrollbars"
                />
              </div>
            </div>
          </div>
        </advanced-card>

        <advanced-card
          :init-collapsed="false"
          title="Close Button"
        >
          <div class="list-item">
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  :id="`adtag-close-button-enabled`"
                  label="Enable close"
                  :value="settings.proTab.closeButton.enabled"
                  @input="updateCloseButtonEnabled"
                />
              </div>
            </div>
          </div>
          <div
            v-if="settings.proTab.closeButton.enabled"
            class="list-item"
          >
            <label class="input-label">Icon size</label>
            <div class="form-group">
              <text-input
                id="adtag-close-button-dimensions"
                :is-draggable="true"
                :max-width="105"
                :min-width="105"
                name="closeButtonSize"
                type="text"
                :value="settings.proTab.closeButton.size"
                @change="updateCloseButtonSize"
              />
            </div>
          </div>
          <div
            v-if="settings.proTab.closeButton.enabled"
            class="list-item"
          >
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="adtag-close-button-dead-area-enabled"
                  v-model:value="settings.proTab.closeButton.deadArea"
                  label="Enable dead area"
                />
              </div>
            </div>
          </div>
          <div
            v-if="settings.proTab.closeButton.enabled && settings.proTab.closeButton.deadArea"
            class="list-item"
          >
            <label class="input-label">Dead area size</label>
            <div class="form-group">
              <text-input
                id="adtag-close-button-dead-area-dimensions"
                :is-draggable="true"
                :max-width="105"
                :min-width="105"
                name="dimensionsW"
                type="text"
                :value="settings.proTab.closeButton.deadAreaSize"
                @change="updateDeadAreaSize"
              />
            </div>
          </div>
          <div
            v-if="settings.proTab.closeButton.enabled"
            class="list-item mb-5"
          >
            <div class="form-group">
              <input-dropdown
                class="without-highlight"
                label="Close button position"
                :options="availableCloseButtonPosition"
                placeholder="Select button position"
                :allow-empty="false"
                :preselect-first="true"
                :searchable="false"
                :show-labels="false"
                style="height:38px"
                :track-by="null"
                :min-width="222"
                :value="settings.proTab.closeButton.position"
                :max-width="222"
                @input="updateCloseButtonPosition"
              >
                <template #single-option="{ option }">
                  {{ option.charAt(0).toUpperCase() + option.slice(1) }}
                </template>
                <template #option-row="{ option }">
                  {{ option.charAt(0).toUpperCase() + option.slice(1) }}
                </template>
              </input-dropdown>
            </div>
          </div>
        </advanced-card>

        <advanced-card
          :init-collapsed="false"
          title="MRAID"
        >
          <div class="list-item">
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="adtag-mraid-enabled"
                  v-model:value="settings.proTab.mraid"
                  label="Enable MRAID"
                />
              </div>
            </div>
          </div>
        </advanced-card>
        <advanced-card
          :init-collapsed="false"
          title="Tracking"
        >
          <div class="list-item">
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="adtag-pointer-click-enabled"
                  v-model:value="settings.proTab.pointerClick"
                  label="Enable pointer click"
                />
              </div>
            </div>
          </div>
          <div class="list-item">
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="adtag-prevent-scroll-enabled"
                  v-model:value="settings.proTab.preventScroll"
                  label="Prevent scroll"
                />
              </div>
            </div>
          </div>
          <div class="list-item">
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="adtag-click-out-fallback-enabled"
                  v-model:value="settings.proTab.clickOutFallback"
                  label="Enable clickOutFallback"
                />
              </div>
            </div>
          </div>
        </advanced-card>
        <advanced-card
          :init-collapsed="false"
          title="Group macro"
        >
          <div class="list-item">
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="adtag-show-group-macros-enabled"
                  v-model:value="settings.proTab.groupMacro.configurable"
                  label="Show group macros"
                />
              </div>
            </div>
          </div>
          <div
            v-if="settings.proTab.groupMacro.configurable"
            class="list-item"
          >
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="adtag-add-group-macros-enabled"
                  v-model:value="settings.proTab.groupMacro.enabled"
                  label="Add group macro by default"
                />
              </div>
            </div>
          </div>
          <div
            v-if="settings.proTab.groupMacro.configurable"
            class="list-item"
          >
            <div class="form-group">
              <text-input
                id="adtag-group-macro-value"
                v-model:value="settings.proTab.groupMacro.value"
                label="Group macro value"
              />
            </div>
          </div>
        </advanced-card>

        <advanced-card
          :init-collapsed="false"
          title="Time tracking"
          tooltip="Disabled by default."
        >
          <div class="list-item">
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="adtag-timetracking-enabled"
                  v-model:value="settings.proTab.timeTracking"
                  label="Enable Time tracking"
                />
              </div>
            </div>
            <div v-if="settings.proTab.timeTracking">
              <label class="input-label">Timetracking interval</label>
              <div class="form-group">
                <text-input
                  id="adtag-timetracking-interval"
                  :is-draggable="true"
                  :max-width="222"
                  :min="0"
                  :max="100000"
                  :min-width="222"
                  name="timetrackingInterval"
                  suffix="ms"
                  type="number"
                  :value="settings.proTab.timeTrackingInterval"
                  @change="updateTimeTrackingInterval"
                />
              </div>
            </div>
          </div>
        </advanced-card>
        <advanced-card
          :init-collapsed="false"
          title="Unique click by name"
        >
          <div class="list-item">
            <div class="form-group">
              <div class="toggle-wrapper end">
                <toggle
                  id="adtag-unique-click-by-name-enabled"
                  v-model:value="settings.proTab.uniqueClickByName"
                  label="Enable unique click by name"
                />
              </div>
            </div>
          </div>
        </advanced-card>

        <autoclose
          v-bind="autoclose"
          @update="updateAutoclose($event)"
        />
        <custom-code
          :enable-modal="false"
          :value="customCode"
          @update="updateCustomCode($event)"
        />

        <advanced-card
          :init-collapsed="false"
          title="Domains"
        >
          <div
            class="list-item"
          >
            <div class="form-group">
              <label class="input-label">
                Libs domain
              </label>
              <div class="inline">
                <text-input
                  v-model:value="settings.libsDomain"
                  :height="38"
                  :max-width="222"
                  :min-width="222"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="input-label">
                CDN domain
              </label>
              <div class="inline">
                <text-input
                  v-model:value="settings.cdnDomain"
                  :height="38"
                  :max-width="222"
                  :min-width="222"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="input-label">
                Collector domain
              </label>
              <div class="inline">
                <text-input
                  v-model:value="settings.collectorDomain"
                  :height="38"
                  :max-width="222"
                  :min-width="222"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="input-label">
                Adscript Url
              </label>
              <div class="inline">
                <text-input
                  v-model:value="settings.overrideAdscriptUrl"
                  :height="38"
                  :max-width="222"
                  :min-width="222"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="input-label">
                Showroom Domain
              </label>
              <div class="inline">
                <text-input
                  v-model:value="settings.showroomDomain"
                  :height="38"
                  :max-width="222"
                  :min-width="222"
                />
              </div>
            </div>
          </div>
        </advanced-card>
      </div>
    </template>
    <template #actions>
      <base-button
        :min-width="94"
        size="l"
        @click.prevent="modal.close"
      >
        {{ cancelButton }}
      </base-button>
      <primary-button
        :min-width="114"
        size="l"
        @click.prevent="onSubmit"
      >
        {{ actionButton }}
      </primary-button>
    </template>
  </base-modal>
</template>

<script>
import { CompanyRoutes } from "../../../api/routes"
import ClickMacro from "../../../clickMacro"
import Utils from "../../../utils"
import Autoclose from "@/components/campaign/adtags/options/Autoclose"
import InputDropdown from "@/components/common/dropdown/InputDropdown.vue"
import CustomCode from "@/components/campaign/adtags/options/CustomCode.vue"
import Toggle from "@/components/common/Toggle.vue"

export default {
  components: { Toggle, CustomCode, InputDropdown, Autoclose },
  props: {
    cancelButton: {
      type: String,
      default: "Cancel"
    },
    actionButton: {
      type: String,
      default: "Save"
    },
    successMessage: {
      type: String,
      default: "Successfully updated company settings"
    },
    companyUuid: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      modal: {
        close: () => {
        }
      },
      campaignOrderByOptions: [
        { name: "Last updated", value: "last_edit" },
        { name: "Created at", value: "created_at" }
      ],
      settings: {
        showFullLengthCampaignName: false,
        showFullLengthDesignName: false,
        sortCampaignsBy: "last_edit",
        tracking: {
          nativeTracking: false
        },
        proTab: {
          clickMacro: {
            name: "Empty",
            customClickMacro: ""
          },
          adSize: {
            enabled: false,
            width: "100%",
            height: "100%"
          },
          specialFormat: {
            enabled: false,
            name: "interstitial",
            options: {
              preventScroll: true,
              width: "100%",
              height: "100%"
            }
          },
          closeButton: {
            name: "closeButton",
            enabled: false,
            size: "24px",
            deadArea: true,
            deadAreaSize: "9vw",
            position: "right"
          },
          mraid: false,
          timeTracking: false,
          timeTrackingInterval: 2000,
          groupMacro: {
            name: "groupMacro",
            enabled: false,
            configurable: false,
            value: ""
          },
          uniqueClickByName: false,
          pointerClick: false,
          clickOutFallback: false,
          preventScroll: false,
          autoclose: {
            name: "autoclose",
            enabled: false,
            duration: 10000,
            cancelOnInteraction: true
          },
          customCode: null
        },
        libsDomain: "libs.adtron.io",
        cdnDomain: "cdn.adtron.io",
        collectorDomain: "",
        overrideAdscriptUrl: "",
        showroomDomain: ""
      }
    }
  },
  computed: {
    availableClickMacros () {
      return ClickMacro.getNames()
    },
    autoclose () {
      const preparedAutoCloseData = {
        ...this.settings.proTab.autoclose,
        duration: String(this.settings.proTab.autoclose.duration)
      }
      return preparedAutoCloseData
    },
    customCode () {
      return this.settings.proTab.customCode
    },
    availableSpecialFormats () {
      return ["interstitial", "interscroller"]
    },
    availableCloseButtonPosition () {
      return ["left", "right"]
    },
    viewabilityShowThresholdPercent () {
      return (this.settings.proTab.specialFormat?.options?.viewabilityShowThreshold * 100) + "%"
    }
  },
  mounted () {
    this.modal = this.$refs.modal
    const url = CompanyRoutes.getCompanySettings(this.companyUuid)
    this.$apiClient.get(url).then((res) => {
      const { settings } = res.data.data
      this.settings = { ...this.settings, ...settings }
    })
  },
  methods: {
    updateSortCampaignsBy ({ value }) {
      this.settings.sortCampaignsBy = value
    },
    updateTimeTrackingInterval (val) {
      this.settings.proTab.timeTrackingInterval = Utils.clamp(0, val, 100000)
    },
    updateSpecialFormatEnabled (val) {
      if (!val) {
        this.settings.proTab.specialFormat.name = "interstitial"
      }
      this.settings.proTab.specialFormat.enabled = val
    },
    updateCustomAdWidth (val) {
      this.settings.proTab.adSize.width = this.parseSize(val)
    },
    updateCustomAdHeight (val) {
      this.settings.proTab.adSize.height = this.parseSize(val)
    },
    updateCloseButtonSize (val) {
      this.settings.proTab.closeButton.size = this.parseSize(val)
    },
    updateAutoclose (value) {
      const updatedValue = { ...value, duration: parseInt(value.duration) }
      this.settings.proTab.autoclose = updatedValue
    },
    updateCustomCode (value) {
      this.settings.proTab.customCode = value
    },
    updateDeadAreaSize (val) {
      this.settings.proTab.closeButton.deadAreaSize = this.parseSize(val)
    },
    updateCloseButtonPosition (val) {
      this.settings.proTab.closeButton.position = val
    },
    updateInterscrollerFrameWidth (val) {
      this.settings.proTab.specialFormat.options.width = this.parseSize(val)
    },
    updateInterscrollerFrameHeight (val) {
      this.settings.proTab.specialFormat.options.height = this.parseSize(val)
    },
    updateInterscrollerViewabilityShowThreshold (val) {
      this.settings.proTab.specialFormat.options.viewabilityShowThreshold = parseInt(val) / 100
    },
    updateSpecialFormatName (val) {
      this.settings.proTab.specialFormat.name = val

      if (val === "interstitial") {
        this.settings.proTab.specialFormat.options = {
          preventScroll: true,
          width: "100%",
          height: "100%"
        }
      } else if (val === "interscroller") {
        this.settings.proTab.specialFormat.options = {
          showBars: true,
          fullHeightMode: true,
          width: "100%",
          height: "100%",
          viewabilityShowThreshold: 0.2
        }
      }
    },
    updateCloseButtonEnabled (val) {
      this.settings.proTab.closeButton.enabled = val
    },
    parseSize (val) {
      const regex = /\d*\.?\d+(?:px|%|vh|vw|em)?/i

      // If only number entered add px as postfix
      if (!isNaN(Number(val))) {
        return `${val}px`
      }

      if (regex.test(val)) {
        return val
      }

      return "100%"
    },
    updateClickMacro (val) {
      if (val !== "Custom") {
        this.settings.proTab.clickMacro.customClickMacro = ""
      }
      this.settings.proTab.clickMacro.name = val
    },
    onSubmit () {
      const url = CompanyRoutes.updateCompanySettings(this.companyUuid)
      this.$apiClient.put(url, { settings: this.settings }).then(() => {
        this.$toasted.success(this.successMessage)
      }).finally(() => {
        this.modal.close()
      })
    }
  }
}
</script>
